import { render } from "./ChangePasswordWithToken.vue?vue&type=template&id=109834b6"
import script from "./ChangePasswordWithToken.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordWithToken.vue?vue&type=script&lang=ts"
script.render = render

export default script